import { Button, Form, Input, Modal } from "antd";

const NewAdminFormModal = ({
  isModalOpen = false,
  setIsModalOpen = () => {},
  handleCreateAdmin = () => {}
}) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = (values) => {
    handleCreateAdmin(values);
  };

  return (
    <Modal
      title="Create New Admin"
      open={isModalOpen}
      footer={[]}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Form form={form} name="new_admin_form" onFinish={handleFormSubmit}>
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Please enter the admin's name!"
            }
          ]}
        >
          <Input prefix={<i className="fa fa-ship" aria-hidden="true" />} placeholder="John Doe" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              required: true,
              message: "Please enter the admin's email!"
            }
          ]}
        >
          <Input
            prefix={<i className="fa fa-ship" aria-hidden="true" />}
            placeholder="john@doe.com"
          />
        </Form.Item>

        <Form.Item
          name="contactNumber"
          label="Contact Number"
          rules={[
            {
              required: true,
              message: "Please enter the admin's number!"
            }
          ]}
        >
          <Input
            prefix={<i className="fa fa-ship" aria-hidden="true" />}
            placeholder="+91 XXXXXXXXXX"
          />
        </Form.Item>

        <Form.Item
          name="password"
          label="Password"
          rules={[
            {
              required: true,
              message: "Please enter the admin's password!"
            }
          ]}
        >
          <Input prefix={<i className="fa fa-ship" aria-hidden="true" />} placeholder="********" />
        </Form.Item>

        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            Create Admin
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default NewAdminFormModal;
